var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8437",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8437",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADjUlEQVR4nO2dvYtcVRyG36MShSgGN4gRlE2nlViIjR+JlYrBwsImooXEwr8ghVhYuEJsDATEQkkvyYKihZWtrmBsLGPWuKhswMWPhEAeixllPNyYhftxXob36ebe4Xffc557zp2ZYn5SCCGEEEIYntLy4sBBSS9KelrSqqQDkvY0iHJJ0pakDUlnJX1WSrncIEcbgHuB08A1PLkAvAzc1HquRgd4FthpO9+75gxw+5TzM+mWBbwi6QNJt0x53Z58I+nJUsrvrYMMCnAIuNpxF/4EHAceAFo8PwTcBTwGvAf8dZ2VsjzbF7Af+LljoKeBO1vnWwRYBb7uyPpS62yDAZzoGOAJoOmnvOsB7O2Q8gNwW+tsvQHu7tgGzrrK+If5SqlzP986V2+AV6tB7QD3tM61G4CTVfaPWmfqDbBeDerd1pl2C/B4lf1c60y9Ab6vBvVodf4FYJv2bALPVNlWqvdsjz1fo+/jwI6kOxYO7Sul/LZwfkuSyxa2WUq5f/EAwOLrUsqoczaFkP8dUH2+NTfKN7aQ5fmysyTY/YQx9h1Y47ZCs0LMiBAzIsSMCDEjQsyIEDMixIwIMSNCzIgQMyLEjAgxI0LMiBAzIsSMCDEjQsyIEDMixIwIMSNCzIgQMyLEjAgxI0LMiBAzIsSMCDEjQsyIEDMixIwIMSNCzIgQMyLEjAgxI0LMiBAzIsSMCDEjQsyIEDMixIwIMSNCzIgQMyLEjAgxI0LMiBAzIsSMCDEjQsyIEDMixIwIMSNCzLD7Z2u3f5qemqwQMxyE/Ng6wAKbrQM4CDkmg4nQLMOx1iFGB7hcdamxapN3I+o2PGNfb4oV8mv1enWowsAe4B1mzSkvAmsM2JwSWKkOXRqqdjOAT6qb7I0Ba6919JJaG7D+E1XtpWgK9no1qAsM1PB3vipqLg5Re16/bpv34VC1m8Gsz+wf1cDeH6j2aEKAgyxjY0lJAt7smLi3BqjbtWW9PUDdvcBGVfc8y9B6Vfr34ftdx+StAwd61l2br5RBHurzlVHLADjap64dwIPALx0D/RM4BRwG9jXKtsLsAX6S7vbdHzNR796pO6I9JOkLSfunvG5PNiQdmqrB/aTf1Esp30p6WNKXU163B59KemoqGc0AbgZeY/YR2JHzwFEatBhv2tMcuFXSc5KOSHpE0n36b9/cqdiWtCXpK0nrkj4vpVxpkCOEEEIIIYzC3we7Dx8s8u9wAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.e130c40e68e051cbc0d117dd3b75d464.svg";
export { ForwardRef as ReactComponent };